import BrandModelSingleSelect from './brandModelSingleSelect.container';

export default BrandModelSingleSelect